'use client'

import { usePageViewEvent } from '@/hooks/gtm/use-page-view-event'
import { useSignUpEvent } from '@/hooks/gtm/use-sign-up-event'

export const GAProvider = ({ children }: { children: React.ReactNode }) => {
  useSignUpEvent()
  usePageViewEvent()
  return <>{children}</>
}
